import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../shared';
import { MessageComponent } from './message';


/**
* Component to handle feedback messages on canvas view.
*/
@Component({
	selector: 'messages',
	templateUrl: './messages.component.html',
	imports: [
		MessageComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class MessagesComponent extends BaseComponent { }
